/** Public documentation: the owner and broker entries, grouped by screen (HELP_SYSTEM_SPEC §5). */
import { useState } from "react";
import { bySurface, searchHelp, bodyHtml, PUBLIC_AUDIENCES, type HelpEntry } from "@oc/help";
import { h, Section, Field, HelpBadge, type ReactNode } from "@oc/ui";
import { Page } from "../layout.ts";

function Entry({ e }: { e: HelpEntry }): ReactNode {
  return h("article", { id: e.id, className: "oc-help", style: { marginBottom: "18px" } },
    h("div", { className: "hd" }, h("span", { className: "eyebrow" }, `${e.surface} · ${e.screen}`)),
    h("div", { className: "title" }, e.title), h("div", { className: "oc-caption" }, e.label),
    h("div", { className: "body", dangerouslySetInnerHTML: { __html: bodyHtml(e) } }));
}

export function HelpPage(): ReactNode {
  const [q, setQ] = useState("");
  const groups = bySurface(PUBLIC_AUDIENCES);
  const hits = q.trim() === "" ? null : searchHelp(q, 20, PUBLIC_AUDIENCES);
  return h(Page, { screen: "help" },
    h(Section, { title: h("span", null, "Help", h(HelpBadge, { id: "web.help" })), lead: "Every explanation this site carries, in one place — the same text the sidebar and the small i marks show.", level: 1 },
      h("div", { style: { maxWidth: "36em" } }, h(Field, { label: "Search", value: q, onChange: setQ, placeholder: "a word from any page" })),
      hits !== null ? h("div", { style: { marginTop: "20px" } }, ...hits.map((e) => h(Entry, { key: e.id, e })))
        : h("div", { style: { marginTop: "20px" } }, ...Object.entries(groups).flatMap(([surface, screens]) => [
          h("h2", { key: surface, className: "oc-h3", style: { marginTop: "24px" } }, surface),
          ...Object.entries(screens).flatMap(([, entries]) => entries.map((e) => h(Entry, { key: e.id, e })))]))),
  );
}
